import React from "react";
import MapWrapper from "../../Map/MapWrapper";
import Marker from "../../Map/Marker";
import { BsFillHouseFill } from "react-icons/bs";
import { FaCircle } from "react-icons/fa";
import { makePlural } from "../../../support/helpers";
import Terrain from "../../Map/controlls/Terrain";
import Zoom from "../../Map/controlls/Zoom";
import { useSelector, useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import InfoSlider from "../../Map/InfoSlider";
import Curtain from "../../Curtain";

const MapContent = ({ markers, listings, isTablet, hideControls }) => {
    const selectedMarker = useSelector((state) => state.map.selectedMarker);
    const dispatch = useDispatch();
    const history = useHistory();

    return (
        <Curtain
            // Only show the Curtain if there are no markers (because its missing longitude and latitude) but there are listings
            show={!markers && listings}
            className="curtain h-100"
            label="Location not available"
        >
            <div className="h-100 position-relative">
                <div
                    className="position-absolute bg-white text-primary px-3 py-2 m-3 d-flex align-items-center align-middle lh-1"
                    style={{ zIndex: 17 }}
                >
                    <BsFillHouseFill
                        size="1.5rem"
                        style={{ marginTop: "-2px" }}
                    />
                    <span className="mx-2">
                        {markers?.length || 0}{" "}
                        {makePlural("Listing", "Listings", markers?.length)}
                    </span>
                    <FaCircle style={{ fontSize: "0.75rem" }} />
                </div>

                {/* Map Controls */}
                <div
                    className="position-absolute d-flex align-items-end d-none d-md-flex"
                    style={{ zIndex: 16, bottom: "25px", right: "10px" }}
                >
                    <Terrain className="me-2" />
                    <Zoom />
                </div>

                <MapWrapper
                    defaultCenter={
                        markers?.[0]?.lat ? markers[0] : { lat: 35, lng: -97 }
                    }
                    defaultZoom={9}
                    dynamicMapHeight="100%"
                    setBounds={() => {}}
                    hideControls={hideControls}
                >
                    {markers?.[0]?.lat &&
                        markers?.map((marker) => (
                            <Marker
                                key={marker?.id}
                                lat={marker?.lat}
                                lng={marker?.lng}
                                marker={marker}
                                markerRadius={6}
                                showInfoSliderOnMobile={!isTablet}
                            />
                        ))}
                </MapWrapper>
                {/* Show InfoSlider only on mobile and if a marker is selected */}
                {selectedMarker && (
                    <div
                        className="d-md-none d-block"
                        style={{
                            position: "absolute",
                            bottom: 0,
                            left: 0,
                            right: 0,
                            zIndex: 2000,
                        }}
                    >
                        <InfoSlider
                            marker={selectedMarker}
                            dispatch={dispatch}
                            history={history}
                        />
                    </div>
                )}
            </div>
        </Curtain>
    );
};

export default MapContent;
